import React, { useState } from "react";

const PersonalDetails = ({ data, setData, errors = {} }) => {
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };

    return (
        <>



            <div className="row g-3">
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            User Name :
                        </label>

                        <div className="input-wrapper">
                            <input
                                name="username"
                               className="custom-input"
                                value={data.username || ""}
                                onChange={handleChange}
                            />
                            {errors.username && <small className="error-text">{errors.username}</small>}
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Password</label>
                        <div className="input-wrapper">
                            <input
                              type="password"
                                name="password"
                               className="custom-input"
                                value={data.password || ""}
                                onChange={handleChange}
                            />
                            {errors.password && <small className="error-text">{errors.password}</small>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Employee ID </label>
                        <div className="input-wrapper">
                            <input
                             type="text"
                                name="employeeId"
                               className="custom-input"
                                value={data.employeeId || ""}
                                onChange={handleChange}
                            />
                            {errors.employeeId && <small className="error-text">{errors.employeeId}</small>}
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Salutation :
                        </label>
                        <div className="input-wrapper">
                            <select
                                name="salutation"
                               className="custom-input"
                                value={data.salutation || ""}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>Mr</option>
                                <option>Miss</option>
                                <option>Mrs</option>
                            </select>
                            {errors.salutation && <small className="error-text">{errors.salutation}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            First Name :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="firstName"
                                className="custom-input"
                                value={data.firstName || ""}
                                onChange={handleChange}
                            />
                            {errors.firstName && <small className="error-text">{errors.firstName}</small>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Last Name :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="lastName"
                                className="custom-input"
                                value={data.lastName || ""}
                                onChange={handleChange}
                            />
                            {errors.lastName && <small className="error-text">{errors.lastName}</small>}

                        </div>
                    </div>
                </div>

                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Gender :
                        </label>
                        <div className="input-wrapper">
                            <select
                                name="gender"
                                className="custom-input"
                                value={data.gender || ""}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>Male</option>
                                <option>Female</option>
                                <option>Other</option>
                            </select>
                            {errors.gender && <small className="error-text">{errors.gender}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Date of Birth :
                        </label>
                        <div className="input-wrapper">
                            <input
                                type="date"
                                name="dob"
                               className="custom-input"
                                value={data.dob || ""}
                                onChange={handleChange}
                            />
                            {errors.dob && <small className="error-text">{errors.dob}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Age :
                        </label>
                        <div className="input-wrapper">
                            <input
                            type="number"
                                name="age"
                               className="custom-input"
                                value={data.age || ""}
                                onChange={handleChange}
                            />
                            {errors.age && <small className="error-text">{errors.age}</small>}

                        </div>
                    </div>
                </div>
                <div className="border_">
                    <span className="border-line"></span>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Blood Group :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="bloodgroup"
                               className="custom-input"
                                value={data.bloodgroup || ""}
                                onChange={handleChange}
                            />
                            {errors.bloodgroup && <small className="error-text">{errors.bloodgroup}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Martial Status :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="martialstatus"
                                className="custom-input"
                                value={data.martialstatus || ""}
                                onChange={handleChange}
                            />
                            {errors.martialstatus && <small className="error-text">{errors.martialstatus}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Present Address :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="presentaddress"
                               className="custom-input"
                                value={data.presentaddress || ""}
                                onChange={handleChange}
                            />
                            {errors.presentaddress && <small className="error-text">{errors.presentaddress}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Permanent Address :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="permanentaddress"
                                className="custom-input"
                                value={data.permanentaddress || ""}
                                onChange={handleChange}
                            />
                            {errors.permanentaddress && <small className="error-text">{errors.permanentaddress}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Father Name :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="fathername"
                               className="custom-input"
                                value={data.fathername || ""}
                                onChange={handleChange}
                            />
                            {errors.fathername && <small className="error-text">{errors.fathername}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Mother Name :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="mothername"
                               className="custom-input"
                                value={data.mothername || ""}
                                onChange={handleChange}
                            />
                            {errors.mothername && <small className="error-text">{errors.mothername}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Mobile Number :
                        </label>
                        <div className="input-wrapper">
                            <input
                             type="number"
                                name="mobilenumber"
                               className="custom-input"
                                value={data.mobilenumber || ""}
                                onChange={handleChange}
                            />
                            {errors.mobilenumber && <small className="error-text">{errors.mobilenumber}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            Aadhar Number :
                        </label>
                        <div className="input-wrapper">
                            <input
                             type="number"
                                name="aadharnumber"
                               className="custom-input"
                                value={data.aadharnumber || ""}
                                onChange={handleChange}
                            />
                            {errors.aadharnumber && <small className="error-text">{errors.aadharnumber}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            PAN Number :
                        </label>
                        <div className="input-wrapper">
                            <input
                             type="text"
                                name="pannumber"
                                className="custom-input"
                                value={data.pannumber || ""}
                                onChange={handleChange}
                            />
                            {errors.pannumber && <small className="error-text">{errors.pannumber}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">

                        <label className="form-label-flex">
                            UAN Number :
                        </label>
                        <div className="input-wrapper">
                            <input
                              type="number"
                                name="uannumber"
                               className="custom-input"
                                value={data.uannumber || ""}
                                onChange={handleChange}
                            />
                            {errors.uannumber && <small className="error-text">{errors.uannumber}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Personal Mail ID :
                        </label>
                        <div className="input-wrapper">
                            <input
                             type="email"
                                name="personalmailid"
                                className="custom-input"
                                value={data.personalmailid || ""}
                                onChange={handleChange}
                            />
                            {errors.personalmailid && <small className="error-text">{errors.personalmailid}</small>}

                        </div>
                    </div>
                </div>
                <div className="">
                    <span className="border-line"></span>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Location :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="location"
                               className="custom-input"
                                value={data.location || ""}
                                onChange={handleChange}
                            />
                            {errors.location && <small className="error-text">{errors.location}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Emergency Number :
                        </label>
                        <div className="input-wrapper">
                            <input
                             type="number"
                                name="emergency"
                               className="custom-input"
                                value={data.emergency || ""}
                                onChange={handleChange}
                            />
                            {errors.emergency && <small className="error-text">{errors.emergency}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Official Mail ID :
                        </label>
                        <div className="input-wrapper">
                            <input
                              type="email"
                                name="officialmailid"
                               className="custom-input"
                                value={data.officialmailid || ""}
                                onChange={handleChange}
                            />
                            {errors.officialmailid && <small className="error-text">{errors.officialmailid}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Reporting Manager :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="reportingmanager"
                               className="custom-input"
                                value={data.reportingmanager || ""}
                                onChange={handleChange}
                            />
                            {errors.reportingmanager && <small className="error-text">{errors.reportingmanager}</small>}

                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Designation :
                        </label>
                        <div className="input-wrapper">
                            <input
                                name="designation"
                               className="custom-input"
                                value={data.designation || ""}
                                onChange={handleChange}
                            />
                            {errors.designation && <small className="error-text">{errors.designation}</small>}

                        </div>
                    </div>
                </div>
          
                <div className="col-lg-4 mb-1">
                    <div className="form-row-flex">
                        <label className="form-label-flex">
                            Profile Image :
                        </label>
                        <div className="input-wrapper">
                            <input
                                type="file"
                                name="profileImage"
                                className="custom-input"
                                accept="image/*"
                                onChange={handleChange}
                            />
                            {errors.profileImage && (
                                <small className="error-text">{errors.profileImage}</small>
                            )}
                        </div>
                    </div>
                </div>
            </div>


        </>

    );
};

export default PersonalDetails;
